import { useLocalStorageStore } from '../stores/localStorageStore';
import { MixpanelEvent, sendPostHogEvent } from '../utils/mixpanelUtil';

const FireFoxModal = ({ setShowFirefoxModal }) => {
  const handleFirefoxModalClose = () => {
    setShowFirefoxModal(false);
    const parsedData = useLocalStorageStore.getState().pwaInstallDeeplink || {};
    if (Object.keys(parsedData).length > 0) {
      MixpanelEvent(
        'cta_clicked',
        {
          isVisible: false,
          ...parsedData,
          cta_context: 'pwa_install_banner',
          cta_page: window.location.pathname,
          cta_content: 'dismiss',
          browser: 'firefox',
        },
        true
      );
      sendPostHogEvent(
        'cta_clicked',
        {
          isVisible: false,
          ...parsedData,
          cta_context: 'pwa_install_banner',
          cta_page: window.location.pathname,
          cta_content: 'dismiss',
          browser: 'firefox',
        },
        true
      );
    }
  };
  return (
    <div className='fixed inset-0 z-[2000] flex items-center justify-center bg-black bg-opacity-50 px-4'>
      <div className='relative w-full max-w-[26em] rounded-xl bg-cardBackground p-6'>
        <div className='space-y-6'>
          <h3 className='text-center text-lg font-medium text-text'>
            Installation Guide
          </h3>
          <p className='text-center text-text'>
            Currently, installation is supported only on Safari and Chrome
            browsers.
          </p>
          <button
            onClick={handleFirefoxModalClose}
            className='text-800 w-full rounded-full bg-border py-3 font-bold text-text'
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FireFoxModal;
